<script setup lang="ts">
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import ActiveFiltersContainer from '../../filter/ActiveFiltersContainer.vue';
    import CoachingFormController from '../../coaching/form/CoachingFormController.vue';
    import { useGetCoachingForm } from '@/js/services/api/coachingForm/coachingFormQueries';
    import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
    import { useScheduleCoaching } from '@/js/stores/scheduleCoaching';

    const props = defineProps<{
        formId: string;
    }>();

    const scheduleCoachingStore = useScheduleCoaching();

    const id = computed(() => scheduleCoachingStore.formData.formId);

    const { data: form, isLoading, refetch } = useGetCoachingForm(id);

    const previewContainerRef = ref<HTMLElement | null>(null);
    const scale = ref(1);

    const DEFAULT_WIDTH = 1000;

    let resizeObserver: ResizeObserver | null = null;

    onMounted(() => {
        if (previewContainerRef.value) {
            resizeObserver = new ResizeObserver((entries) => {
                const width = entries[0].contentRect.width;
                scale.value = Math.min(1, width / DEFAULT_WIDTH);
            });
            resizeObserver.observe(previewContainerRef.value);
        }
    });

    onUnmounted(() => {
        resizeObserver?.disconnect();
    });

    watch(
        () => props.formId,
        () => {
            if (props.formId) {
                refetch();
            }
        },
        { immediate: true }
    );
</script>
<template>
    <div class="flex flex-col h-full min-h-100">
        <div class="w-full flex bg-white border-b border-gray-light pt-4 -mt-px">
            <ActiveFiltersContainer :filter-store-name="FilterStoreName.ScheduleCoachingFilter" />
        </div>
        <div class="overflow-scroll w-full flex-1 min-h-0">
            <div ref="previewContainerRef" class="w-full p-6 overflow-hidden">
                <div
                    v-if="!isLoading && form"
                    class="bg-white rounded-lg shadow-lg p-6 mx-auto max-w-[1000px]"
                    :style="{
                        zoom: scale,
                    }"
                >
                    <CoachingFormController :form="form" preview />
                </div>
            </div>
        </div>
    </div>
</template>
